/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import {useIntl} from 'react-intl'
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import {SidebarMenuItem} from './SidebarMenuItem'
import {useAuth} from '../../../../../app/modules/auth'

const SidebarMenuMain = () => {
  const intl = useIntl()
  const {currentUser} = useAuth()
  return (
    <>
      <SidebarMenuItem
        to='/dashboard'
        title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
        customIconHtml={
          <span className='menu-icon'>
            <i className='fa-solid fa-chart-column'></i>
          </span>
        }
      />
      <SidebarMenuItem
        to='/apps/kanger-wholesale'
        title='Kanger Wholesale'
        customIconHtml={
          <span className='menu-icon'>
            <i className='fa-solid fa-tag'></i>
          </span>
        }
      />
      <SidebarMenuItem
        to='/apps/pleasurespot-products'
        title='PleasureSpot Products'
        customIconHtml={
          <span className='menu-icon'>
            <i className='fa-solid fa-store'></i>
          </span>
        }
      />
      <SidebarMenuItem
        to='/apps/pleasurespot-completion'
        title='Data Completion'
        customIconHtml={
          <span className='menu-icon'>
            <i className='fa-solid fa-list-check'></i>
          </span>
        }
      />
      {/* <SidebarMenuItemWithSub
        to='#'
        title='Apps'
        customIconHtml={
          <span className='menu-icon'>
            <i className='fa-solid fa-tags'></i>
          </span>
        }
        roleNeeded={['admin', 'client']}
      > */}
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-uppercase fs-8 ls-1'>APPS</span>
        </div>
      </div>
      <SidebarMenuItemWithSub
        to='#'
        title='Blog Writers'
        customIconHtml={
          <span className='menu-icon'>
            <i className='fa-solid fa-pen-to-square'></i>
          </span>
        }
        roleNeeded={['admin', 'client']}
      >
        <SidebarMenuItem
          to='apps/auto-blogger'
          title='Auto Blogger'
          customIconHtml={
            <span className='menu-icon'>
              <i className='fa-solid fa-rss'></i>
            </span>
          }
          roleNeeded={['admin', 'client']}
        />
        <SidebarMenuItem
          to='apps/shopify-auto-writer'
          title='Collection Writer'
          customIconHtml={
            <span className='menu-icon'>
              <i className='fa-solid fa-tags'></i>
            </span>
          }
          roleNeeded={['admin', 'client']}
        />
        <SidebarMenuItem
          to='apps/manual-writer'
          title='Manual Writer'
          customIconHtml={
            <span className='menu-icon'>
              <i className='fa-solid fa-book'></i>
            </span>
          }
          roleNeeded={['admin', 'client']}
        />
        <SidebarMenuItem
          to='apps/review-writer'
          title='Review Writer'
          customIconHtml={
            <span className='menu-icon'>
              <i className='fa-solid fa-star'></i>
            </span>
          }
          roleNeeded={['admin', 'client']}
        />
      </SidebarMenuItemWithSub>
      <SidebarMenuItem
        to='apps/shopify-product-assistant'
        title='Product Assistant'
        customIconHtml={
          <span className='menu-icon'>
            <i className='fa-solid fa-tag'></i>
          </span>
        }
        roleNeeded={['admin', 'client']}
      />
      
      <SidebarMenuItem
        to='apps/inner-linker'
        title='Auto Inner Linker'
        customIconHtml={
          <span className='menu-icon'>
            <i className='fa-solid fa-tag'></i>
          </span>
        }
        roleNeeded={['admin', 'client']}
      />
      {/* </SidebarMenuItemWithSub> */}
      <hr style={{margin:"10px 10%"}}></hr>
      <SidebarMenuItemWithSub
        to='#'
        title='Config'
        customIconHtml={
          <span className='menu-icon'>
            <i className='fa-solid fa-cog'></i>
          </span>
        }
        roleNeeded={['admin', 'client']}
      >
      <SidebarMenuItem
        to='innerlink-map'
        title='InnerLink Map'
        customIconHtml={
          <span className='menu-icon'>
            <i className='fa-solid fa-tag'></i>
          </span>
        }
        roleNeeded={['admin', 'client']}
      /></SidebarMenuItemWithSub>

{currentUser?.decoded?.role === 'admin' ? (
        <>
          <div className='menu-item'>
            <div className='menu-content pt-8 pb-2'>
              <span className='menu-section text-uppercase fs-8 ls-1'>Admin Center</span>
            </div>
          </div>
          <SidebarMenuItem
            to='/user-management'
            title='Users'
            customIconHtml={
              <span className='menu-icon'>
                <i className='fa-solid fa-crown'></i>
              </span>
            }
          />
          <SidebarMenuItem
            to='admin/shopify-stores'
            title='Shopify Stores'
            customIconHtml={
              <span className='menu-icon'>
                <i className='fa-solid fa-crown'></i>
              </span>
            }
          />
        </>
      ) : null}
    </>
  )
}

export {SidebarMenuMain}
